import React, { useCallback, useMemo, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { NoFile, UploadComponent } from "./styles";
import { Modal, TabContainer } from "../1-Layout/styles";
import { FlexContainer, Subtitle } from "../../../styles";
import {
  Description,
  FormItem,
} from "../../../../../components/ControlledInputs/styles";

import { FiArrowRight } from "react-icons/fi";

import { Tabs } from "antd";
import { Image, Upload, message } from "antd";
import Button from "../../Button";
import SquareShape from "../../Shapes/Squares";
import HorizontalRectangleShape from "../../Shapes/Horizontal Rectangles";
import VerticalRectangleShape from "../../Shapes/Vertical Rectangles";

export default function ImageUploader({
  setConfirmedImage,
  layout,
  nextStep,
  fileList,
  setFileList,
  uploadImgUrl,
  setUploadImgUrl,
}) {
  const intl = useIntl();
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewZoomOpen, setPreviewZoomOpen] = useState(false);

  const handleConfirm = () => {
    setConfirmedImage(uploadImgUrl);
    setPreviewVisible(false);
    nextStep();
  };

  const handleCancel = () => {
    setPreviewVisible(false);
    setUploadImgUrl(null);
    setFileList([]);
  };

  const handleDelete = useCallback(() => {
    setUploadImgUrl(null);
    setFileList([]);
  }, [setUploadImgUrl, setFileList]);

  const uploadProps = useMemo(
    () => ({
      beforeUpload: (file) => {
        const isValidType = ["image/png", "image/jpeg", "image/jpg"].includes(
          file.type
        );
        if (!isValidType) {
          message.error(
            intl.formatMessage({
              id: "ai_creator.image.upload.error",
            })
          );
          return Upload.LIST_IGNORE;
        }

        const isLessThan1_5MB = file.size / 1024 / 1024 < 1.5;
        if (!isLessThan1_5MB) {
          message.error(
            intl.formatMessage({
              id: "ai_creator.image.upload.error.size",
            })
          );
          return Upload.LIST_IGNORE;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          setUploadImgUrl(reader.result);
          setPreviewVisible(true);
        };
        return false;
      },
      fileList,
      onChange: ({ fileList }) => {
        return fileList.length > 0 ? setFileList(fileList) : handleDelete();
      },
      onPreview: () => {
        setPreviewZoomOpen(true);
      },
      maxCount: 1,
      showUploadList: true,
    }),
    [fileList, handleDelete, intl, setFileList, setUploadImgUrl]
  );

  return (
    <div>
      <Subtitle>
        <FormattedMessage id={"ai_creator.image.label.upload"} />
      </Subtitle>

      <div>
        <FormItem>
          <UploadComponent
            {...uploadProps}
            listType={"picture-card"}
            fileList={fileList}
          >
            {fileList?.length >= 1 ? null : (
              <FlexContainer direction="column">
                <FlexContainer gap={"8px"}>
                  <Button label={"upload"} theme={"upload"} />
                  <NoFile>
                    <FormattedMessage id={"ai_creator.upload.noFile"} />
                  </NoFile>
                </FlexContainer>
                <Description creator>
                  {intl.formatMessage({
                    id: `ai_cretor.images.upload.desc`,
                  })}
                </Description>
              </FlexContainer>
            )}
          </UploadComponent>
        </FormItem>

        {previewZoomOpen && (
          <Image
            wrapperStyle={{
              display: "none",
            }}
            movable={false}
            zoom={{
              min: 0.3,
              max: 1,
              step: 0.01,
            }}
            preview={{
              visible: previewZoomOpen,
              onVisibleChange: (visible) => setPreviewZoomOpen(visible),
              scaleStep: 0.5,
              defaultScale: 0.3,
            }}
            src={uploadImgUrl}
          />
        )}

        {uploadImgUrl && (
          <FlexContainer width="250px" gap="8px" marginTop="24px" animated>
            <Button
              onClick={handleConfirm}
              size={"modal"}
              label={"foward"}
              icon={<FiArrowRight size={20} />}
            />
          </FlexContainer>
        )}
      </div>

      <PreviewModalBeforeContinue
        handleCancel={handleCancel}
        handleConfirm={handleConfirm}
        previewImage={uploadImgUrl}
        previewVisible={previewVisible}
        layout={layout}
      />
    </div>
  );
}

function PreviewModalBeforeContinue({
  previewVisible,
  previewImage,
  layout,
  handleConfirm,
  handleCancel,
}) {
  return (
    <Modal
      open={previewVisible}
      onOk={handleConfirm}
      closable={false}
      onCancel={handleCancel}
      footer={""}
    >
      <Tabs defaultActiveKey="1" centered>
        <Tabs.TabPane tab="Imagem" key="1">
          <TabContainer>
            <img
              alt="preview"
              style={{
                width: "292px",
                height: "365px",
                objectFit: "cover",
              }}
              src={previewImage}
            />
          </TabContainer>
        </Tabs.TabPane>

        <Tabs.TabPane tab="1080 x 1350" key="2">
          <TabContainer>
            <SquareShape
              size={292}
              variantColor={layout.color}
              shape={layout.layout}
              imageUrl={previewImage}
            />
          </TabContainer>
        </Tabs.TabPane>

        <Tabs.TabPane tab="1200 x 628" key="3">
          <TabContainer>
            <HorizontalRectangleShape
              size={292 + 164.25 + 16}
              variantColor={layout.color}
              shape={layout.layout}
              imageUrl={previewImage}
            />
          </TabContainer>
        </Tabs.TabPane>
        <Tabs.TabPane tab="1080 x 1920" key="4">
          <TabContainer>
            <VerticalRectangleShape
              size={164.25}
              variantColor={layout.color}
              shape={layout.layout}
              imageUrl={previewImage}
            />
          </TabContainer>
        </Tabs.TabPane>
      </Tabs>

      <FlexContainer direction={"row"} gap={"24px"}>
        <Button
          size={"modal"}
          theme={"secondary"}
          onClick={handleCancel}
          label={"cancel"}
        />
        <Button
          onClick={handleConfirm}
          size={"modal"}
          label={"foward"}
          icon={<FiArrowRight size={20} />}
        />
      </FlexContainer>
    </Modal>
  );
}
